import { createSlice } from '@reduxjs/toolkit';

const getInitialLanguage = () => {
  const saved = localStorage.getItem('preferredLanguage');
  const supported = ['ua', 'en', 'pl', 'de', 'es', 'ru'];
  
  if (saved && supported.includes(saved)) {
    return saved;
  }

  const browserLang = navigator.language?.split('-')[0];
  const langMap = {
    uk: 'ua',
    en: 'en',
    ru: 'ru',
    pl: 'pl',
    de: 'de',
    es: 'es',
  };
  
  const detectedLang = langMap[browserLang];
  if (detectedLang && supported.includes(detectedLang)) {
    return detectedLang;
  }
  
  return 'en';
};

const languageSlice = createSlice({
  name: 'language',
  initialState: {
    current: getInitialLanguage(),
    supported: ['ua', 'en', 'pl', 'de', 'es', 'ru']
  },
  reducers: {
    setLanguage: (state, action) => {
      if (state.supported.includes(action.payload)) {
        state.current = action.payload;
        localStorage.setItem('preferredLanguage', action.payload);
      }
    }
  }
});

export const { setLanguage } = languageSlice.actions;
export default languageSlice.reducer;